<template>
  <cat-modal
    :id="id + '-confirm'"
    :open="open"
    :heading="heading"
    :showClose="topCloseButton"
    :showCloseLabel="showCloseButtonLabel"
    :isAlert="isAlert"
    :closeLabel="closeButtonLabel"
    :size="size"
    fixedSize
    @ui-close="cancel"
  >
    <slot>
      <div v-html="msg"></div>
    </slot>
    <template #buttons>
      <slot name="buttons">
        <slot name="button-cancel">
          <cat-btn
            v-if="showCancel"
            :primary="negative"
            :label="cancelLabel"
            @ui-click="cancel"
          ></cat-btn>
        </slot>
        <slot name="button-confirm">
          <cat-btn
            v-if="showConfirm"
            :primary="!negative"
            :label="confirmLabel"
            @ui-click="confirm"
          ></cat-btn>
        </slot>
      </slot>
    </template>
  </cat-modal>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import CatModal from "@/components/catModal/catModal.vue";
import CatBtn from "@/components/catBtn/catBtn.vue";

export default defineComponent({
  name: "ConfirmDialog",
  components: { CatModal, CatBtn },
  props: {
    id: { type: [String, Number] },
    msg: {
      type: String,
      default: "Are you sure you want to delete this entry?",
      description:
        "Message displayed in the confirm dialog, asking for confirmation."
    },
    confirmLabel: {
      type: String,
      default: "Yes, delete",
      description: "Label text for the confirmation button."
    },
    cancelLabel: {
      type: String,
      default: "No, cancel",
      description: "Label text for the cancel button."
    },
    showCancel: {
      type: Boolean,
      default: true,
      description:
        "Determines whether the cancel button is displayed in the dialog."
    },
    showConfirm: {
      type: Boolean,
      default: true,
      description:
        "Determines whether the confirm button is displayed in the dialog."
    },
    target: {
      type: [String, Object, Number, Boolean],
      description:
        "Set the value to null when the dialog is not shown. Passing a target value will open up the confirm dialog."
    },
    heading: {
      type: String,
      default: "Warning",
      description: "Heading text of the confirm dialog."
    },
    topCloseButton: {
      type: Boolean,
      default: true,
      description:
        "Determines whether the top close button is displayed in the modal."
    },
    negative: {
      type: Boolean,
      default: false,
      description:
        "Determines whether the confirm button has a negative action (e.g., cancel, reject)."
    },
    showCloseButtonLabel: {
      type: Boolean,
      default: false,
      description: "Determines whether to show the close button text label."
    },
    closeButtonLabel: {
      type: String,
      default: "Close",
      description: "Close button text label."
    },
    size: {
      type: String,
      default: "small",
      description:
        "Size of the confirm dialog. Options include small, medium, large, extra-large, and full."
    },
    callerId: {
      type: String,
      description: "Element id that invoked the modal"
    },
    isAlert: {
      type: Boolean,
      default: true,
      description:
        "whether the modal should display as an alert dialog or a modal dialog"
    }
  },
  watch: {
    target: function (newtarget, oldtarget) {
      if (newtarget) {
        this.open = true;
      } else {
        this.open = false;
      }
    }
  },
  data: function () {
    return {
      open: false
    };
  },
  mounted: function () {
    if (this.target) {
      this.open = true;
    }
  },
  methods: {
    confirm: function (evt) {
      this.$emit("ui-confirm", { id: this.target, confirm: true, event: evt });
    },
    cancel: function (evt) {
      const cancelBtn = document.getElementById(this.callerId);

      this.$emit("ui-cancel", { id: this.target, confirm: false, event: evt });

      // Focus to trigger button if callerId exist
      if (cancelBtn) {
        cancelBtn.focus();
      }
    }
  }
});
</script>
